<script lang="ts">
  import Alert from '$shared/atoms/Alert/Alert.svelte';
  import { AlertOption } from '$provider/models/AlertOption';
  import type { AlertDetailedInfo } from '$shared/models/AlertDetailedInfo';

  interface Props {
    errorMessage?: AlertDetailedInfo | string | null | undefined;
    infoMessage?: string;
    warnMessage?: string;
    warnClosable?: boolean;
    name?: string;
    children?: import('svelte').Snippet;
    onerrorclose?: () => void;
    oninfoclose?: () => void;
    onwarnclose?: () => void;
  }

  let {
    errorMessage = '',
    infoMessage = '',
    warnMessage = '',
    warnClosable = false,
    name = '',
    children,
    onerrorclose,
    oninfoclose,
    onwarnclose
  }: Props = $props();

  const onClickErrorClose = (): void => {
    onerrorclose?.();
  };
  const onClickInfoClose = (): void => {
    oninfoclose?.();
  };
  const onClickWarnClose = (): void => {
    onwarnclose?.();
  };
</script>

<div data-cy={`${name}-page`} class="page-view">
  {#if errorMessage}
    <div class="page-alert">
      <Alert
        maxWidth
        data={errorMessage}
        closable
        options={AlertOption.errorAlert()}
        onclose={onClickErrorClose}
      />
    </div>
  {/if}
  {#if infoMessage}
    <div class="page-alert">
      <Alert
        maxWidth
        data={infoMessage}
        closable
        options={AlertOption.infoAlert()}
        onclose={onClickInfoClose}
      />
    </div>
  {/if}
  {#if warnMessage}
    <div class="page-alert">
      <Alert
        maxWidth
        data={warnMessage}
        closable={warnClosable}
        options={AlertOption.warnAlert()}
        onclose={onClickWarnClose}
      />
    </div>
  {/if}
  {@render children?.()}
</div>

<style>
  .page-view {
    grid-column: 1 / span 12;
    padding-bottom: 50px;
  }
  .page-alert {
    margin-bottom: 24px;
  }
  .page-alert:first-child {
    margin-top: 24px;
  }
</style>
